import styled from 'styled-components';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import { device } from '../../../constants/StyledComponentConstants';
import { useVideoPlayerConfig } from '../videoHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIFlexContainer = styled(UIFlex).withConfig({
  displayName: "VideoControls__UIFlexContainer",
  componentId: "lretme-0"
})(["border-bottom-left-radius:3px;border-bottom-right-radius:3px;"]);
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "VideoControls__StyledUIButton",
  componentId: "lretme-1"
})(["@media screen and ", "{margin-top:8px;}"], device.mobile);
export const VideoControls = ({
  onFinish,
  onToggleAutoPlay,
  embedCode
}) => {
  const {
    autoPlay,
    toggleAutoPlay
  } = useVideoPlayerConfig();
  const handleChangeAutoplay = () => {
    toggleAutoPlay();
    if (onToggleAutoPlay) onToggleAutoPlay();
  };
  return /*#__PURE__*/_jsxs(UIFlexContainer, {
    direction: "row",
    justify: "between",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(UIFormLabel, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.videoControls.autoPlay"
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: autoPlay,
          className: "m-left-3",
          id: "toggle-button",
          onChange: handleChangeAutoplay,
          size: "extra-small"
        })]
      })
    }), /*#__PURE__*/_jsxs(UIButtonGroup, {
      children: [embedCode && /*#__PURE__*/_jsxs(UICopyButton, {
        hint: I18n.text('learningCenter.videoControls.copyEmbedHint'),
        hintSuccess: I18n.text('learningCenter.videoControls.copyEmbedSuccess'),
        value: embedCode,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "duplicate"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.videoControls.copyEmbedCode"
        })]
      }), !!onFinish && /*#__PURE__*/_jsx(StyledUIButton, {
        onClick: onFinish,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.common.next"
        })
      })]
    })]
  });
};
export default VideoControls;